var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _g, _path9, _path10, _circle2, _line, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgNoEntries = function SvgNoEntries(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 110,
    viewBox: "0 0 136 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876_38488)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illustration-background-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 5C95.6141 5 118 27.3859 118 55C118 82.613 95.6141 105 68 105C40.387 105 18 82.613 18 55C18 27.3859 40.387 5 68 5Z",
    fill: "#303033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-light-fill",
    d: "M30.2815 80.743V51.1812C40.8615 50.3099 46.9294 54.9672 48.6409 57.4047V88.0556C44.4089 80.8363 34.638 80.1725 30.2815 80.743Z",
    fill: "#636669"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-light-fill",
    d: "M68.2449 80.743V51.1812C57.6649 50.3099 51.597 54.9672 49.8855 57.4047V88.0556C54.1175 80.8363 63.8884 80.1725 68.2449 80.743Z",
    fill: "#636669"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-light-fill",
    d: "M26.9536 85.289C36.7245 83.7331 44.1461 85.9373 46.6355 87.2339C41.9679 82.0683 32.9697 81.6068 29.0541 82.0217V54.4048H26.9536V85.289Z",
    fill: "#636669"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-light-fill",
    d: "M23.6731 89.4213C29.3987 87.1808 42.6155 88.9026 47.6721 89.4213C45.0583 86.5584 31.7729 86.1128 25.8087 86.6055V57.1993H23.6731L23.6731 89.4213Z",
    fill: "#636669"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-light-fill",
    d: "M71.8828 85.289C62.1119 83.7331 54.6903 85.9373 52.2009 87.2339C56.8686 82.0683 65.8667 81.6068 69.7824 82.0217V54.4048H71.8828V85.289Z",
    fill: "#636669"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-light-fill",
    d: "M75.1633 89.4213C69.4377 87.1808 56.2209 88.9026 51.1643 89.4213C53.7782 86.5584 67.0635 86.1128 73.0277 86.6055V57.1993H75.1633L75.1633 89.4213Z",
    fill: "#636669"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-light-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.783 38.7429L107.813 34.1143L112.345 31.5843L115.218 36.0633C115.225 36.074 115.175 36.206 115.184 36.2171L110.783 38.7429ZM90.5244 50.2634L86.6445 49.3201L87.5475 45.606L105.192 35.5812L108.178 40.2348L90.5244 50.2634ZM118.241 36.8267C118.422 36.0363 118.268 35.2274 117.83 34.5853L114.978 30.1398C114.561 29.447 113.852 28.931 113.031 28.7207L112.99 28.7109C112.165 28.5102 111.288 28.6303 110.582 29.0364L85.381 43.3908C85.0349 43.5873 84.7864 43.9111 84.6948 44.288L83.3039 50.0087C83.1134 50.7923 83.629 51.5885 84.4574 51.7899L90.454 53.2479C90.851 53.3445 91.2658 53.2892 91.6104 53.0923L116.822 38.733C117.542 38.3167 118.06 37.6217 118.241 36.8267Z",
    fill: "#636669"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_876_38488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 19,
    width: 25,
    height: 25
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5229,
    cy: 31.5222,
    r: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_876_38488)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "illustration-main-fill",
    cx: 44.5229,
    cy: 31.5222,
    r: 12,
    fill: "#12FF80"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.4651,
    y: 34.5569,
    width: 3.06224,
    height: 2.86144,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.6907,
    y: 34.5569,
    width: 5.83637,
    height: 2.86144,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.6907,
    y: 34.5569,
    width: 5.83637,
    height: 2.86144,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7788,
    y: 22.5658,
    width: 15.6816,
    height: 2.86144,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.4028,
    y: 22.5658,
    width: 11.5978,
    height: 2.86144,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.4863,
    y: 25.4272,
    width: 6.08595,
    height: 3.2335,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.572,
    y: 37.4183,
    width: 2.7736,
    height: 4.93624,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.4373,
    y: 37.4183,
    width: 3.05155,
    height: 3.2335,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.3457,
    y: 40.3223,
    width: 17.3977,
    height: 3.2335,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.5273,
    y: 25.4272,
    width: 6.08595,
    height: 3.2335,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5288,
    y: 28.6606,
    width: 6.08595,
    height: 2.86144,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.6086,
    y: 28.6606,
    width: 6.08595,
    height: 2.86144,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.605,
    y: 28.6606,
    width: 5.83637,
    height: 2.86144,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4607,
    y: 37.4183,
    width: 5.94189,
    height: 2.90381,
    fill: "#636669"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.572,
    y: 34.5569,
    width: 5.8886,
    height: 2.86144,
    fill: "#636669"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-light-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8302 23.7201C86.8302 30.3935 81.6068 35.8034 75.1635 35.8034C68.7202 35.8034 63.4968 30.3935 63.4968 23.7201C63.4968 17.0466 68.7202 11.6367 75.1635 11.6367C81.6068 11.6367 86.8302 17.0466 86.8302 23.7201ZM65.8302 23.7201C65.8302 29.0588 70.0088 33.3867 75.1635 33.3867C80.3182 33.3867 84.4968 29.0588 84.4968 23.7201C84.4968 18.3813 80.3182 14.0534 75.1635 14.0534C70.0088 14.0534 65.8302 18.3813 65.8302 23.7201Z",
    fill: "#636669"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-light-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3303 22.5118H79.8303C80.4747 22.5118 80.997 23.0528 80.997 23.7201C80.997 24.3875 80.4747 24.9285 79.8303 24.9285H76.3303V28.5535C76.3303 29.2208 75.808 29.7618 75.1637 29.7618C74.5193 29.7618 73.997 29.2208 73.997 28.5535V24.9285H70.497C69.8527 24.9285 69.3303 24.3875 69.3303 23.7201C69.3303 23.0528 69.8527 22.5118 70.497 22.5118H73.997V18.8868C73.997 18.2195 74.5193 17.6785 75.1637 17.6785C75.808 17.6785 76.3303 18.2195 76.3303 18.8868V22.5118Z",
    fill: "#636669"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "illustration-background-fill illustration-light-stroke",
    cx: 94.6408,
    cy: 75.1496,
    r: 9.17835,
    transform: "rotate(-19.5258 94.6408 75.1496)",
    stroke: "#636669",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "illustration-light-stroke",
    x1: 106.212,
    y1: 78.9738,
    x2: 117.022,
    y2: 83.4472,
    stroke: "#636669",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876_38488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 110,
    fill: "white"
  })))));
};
export default SvgNoEntries;